import { Skeleton } from "@/components/ui/skeleton";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import type { TopReferrerPoint } from "../../api/statsApi";

interface TopReferrersTableProps {
  points: TopReferrerPoint[];
  isLoading: boolean;
}

export const TopReferrersTable = ({
  points,
  isLoading,
}: TopReferrersTableProps) => {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Origen</TableHead>
          <TableHead className="text-right">Sesiones</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {isLoading ? (
          Array.from({ length: 5 }).map((_, idx) => (
            <TableRow key={`skeleton-${idx}`}>
              <TableCell>
                <Skeleton className="h-4 w-3/4" />
              </TableCell>
              <TableCell className="text-right">
                <Skeleton className="ml-auto h-4 w-16" />
              </TableCell>
            </TableRow>
          ))
        ) : points.length === 0 ? (
          <TableRow>
            <TableCell
              colSpan={2}
              className="text-center text-muted-foreground"
            >
              Sin datos
            </TableCell>
          </TableRow>
        ) : (
          points.map((point) => (
            <TableRow key={point.source}>
              <TableCell>{point.source}</TableCell>
              <TableCell className="text-right tabular-nums">
                {point.sessions.toLocaleString("es-AR")}
              </TableCell>
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  );
};
